import { useEventListener } from "@vueuse/core";

const EVENTI = ["mousemove", "keydown", "click", "scroll", "touchstart"] as const;

// Dopo `minuti` senza attività (mouse, tastiera, tocco, scorrimento) disconnette l'utente: chiude la sessione sul server e porta al
// login, dove un avviso spiega il perché. Si usa una volta nel layout dell'app.
export function useIdleLogout(minuti = 20): void {
  const auth = useAuthStore();
  let timer: ReturnType<typeof setTimeout> | undefined;

  const riparti = (): void => {
    clearTimeout(timer);
    timer = setTimeout(() => void auth.esci(true), minuti * 60 * 1000);
  };

  onMounted(riparti);
  for (const evento of EVENTI) useEventListener(import.meta.client ? window : undefined, evento, riparti, { passive: true });
  onBeforeUnmount(() => clearTimeout(timer));
}
